import { render, staticRenderFns } from "./MobileDeviceIcon.vue?vue&type=template&id=4be0d92e&scoped=true"
import script from "./MobileDeviceIcon.vue?vue&type=script&lang=js"
export * from "./MobileDeviceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be0d92e",
  null
  
)

export default component.exports